import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { Page } from '../utils/page';
import { ServiceConfigByCountryAndRole } from '../models/referential/service-config-by-country-and-role.model';
import { SynthesisViewConfig } from '../models/synthesis/synthesis-view-config.model';
import { ParameterRoleService } from '../models/referential/parameter-role-service.model';
import { map } from 'rxjs/operators';
import { ServiceConfig } from '../models/referential/service-config.model';
import { Country } from '../models/referential/country.model';
import { EmployeeRoleEnum } from '../models/employee/employee-role.enum';
import { ReferentialService } from "./referential.service";
import { NumberOfChangeStock } from '../models/number-of-change-stock/number-of-change-stock';
import { Option } from '../models/option/option.model';

@Injectable()
export class OnlineReferentialService extends ReferentialService {

    constructor(
        protected http: HttpClient) {
        super(http);
    }

    getNumberOfChangeStock(): Observable<Page<NumberOfChangeStock>> {
        const numberOfChangeStockUrl = this.API_URL + '/numberStocks';
        return this.http.get<Page<NumberOfChangeStock>>(`${numberOfChangeStockUrl}`);
    }

    getAllServices(filters: Map<string, string>): Observable<Page<ServiceConfigByCountryAndRole>> {
        let params = new HttpParams();
        filters.forEach((value, key) => params = params.set(key, value));
        return this.http.get<Page<ServiceConfigByCountryAndRole>>(this.API_URL, { params });
    }

    getServiceConfigs(roleCode: EmployeeRoleEnum, countryIsoCode: string): Observable<ServiceConfig[]> {
        return this.http.get<ServiceConfig[]>(this.API_URL + `/serviceconfigs/${countryIsoCode}/${roleCode.pricingRole}`);
    }

    getEnabledServiceConfigs(roleCode: EmployeeRoleEnum, countryIsoCode: string): Observable<ServiceConfig[]> {
        return this.getServiceConfigs(roleCode, countryIsoCode)
            .pipe(map(response => response.filter(item => item.isEnabled)));
    }


    getReferential(country: string, role: EmployeeRoleEnum): Observable<any> {
        if (role == null || country == null) {
            return EMPTY;
        }
        return this.findRoleConfig(country, role);
    }


    getSynthesisViewConfig(roleCode: string, countryIsoCode: string): Observable<SynthesisViewConfig[]> {
        return this.http.get<SynthesisViewConfig[]>(this.API_URL + `/synthesis-view-config/${roleCode}/${countryIsoCode}`)
            .pipe(
                map(response => this.getSortedSynthesisViewConfig(response))
            );
    }


    findRoleConfig(countryIsoCode: string, userRole: EmployeeRoleEnum): Observable<any> {
        return this.http.get<ParameterRoleService[]>(this.API_URL + `/role-parameters/${countryIsoCode}/${userRole.pricingRole}`)
            .pipe(
                map((data: ParameterRoleService[]) => {
                    let json: any = {};
                    for (const item of data) {
                        json[item.key] = item.value;
                    }
                    return json;
                })
            );
    }

    getAutomaticArticles(countryCode: string, roleCode: string, serviceCode: string): Observable<any> {
        let params = new HttpParams()
            .set('countryCode', countryCode)
            .set('roleCode', roleCode)
            .set('serviceCode', serviceCode);

        return this.http.get(this.API_URL + '/automatic-articles', { params });
    }

    getCountry(countryIsoCode: string): Observable<Country> {
        return this.http.get<Country>(this.API_URL + `/country/${countryIsoCode}`);
    }

    getOptions(countryIsoCode: string, roleCode: string): Observable<Page<Option>> {
        let params = new HttpParams()
            .set('countries', countryIsoCode)
            .set('role', roleCode)
        return this.http.get<Page<Option>>(this.API_URL + '/options', { params });
    }

    getWashRateNLifetime(countryIsoCode: string, roleCode: string, serviceCode: string, subMarket: string, epi: string, family: string): Observable<any> {
        let params = new HttpParams()
            .set('countryIsoCode', countryIsoCode)
            .set('roleCode', roleCode)
            .set('serviceCode', serviceCode)
            .set('subMarket', subMarket)
            .set('epi', epi)
            .set('family', family);

        return this.http.get<any>(this.API_URL + '/wash-rate-and-lifetime/one', { params });
    }

    getGrossMarginRate(countryIsoCode: string, roleCode: string, serviceCode: string, subMarket: string, family: string, subFamily: string): Observable<any> {
        let params = new HttpParams()
            .set('countryIsoCode', countryIsoCode)
            .set('roleCode', roleCode)
            .set('serviceCode', serviceCode)
            .set('subMarket', subMarket)
            .set('family', family)
            .set('subFamily', subFamily);

        return this.http.get<any>(this.API_URL + '/gross-margin-rates/one', { params });
    }

}


